import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-alert-action-modal',
    templateUrl: './alert-action-modal.component.html',
    styleUrls: ['./alert-action-modal.component.scss'],
    standalone: false
})
export class AlertActionModalComponent implements OnInit {

  title: string = 'Alerta';
  message: string;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

}
